<template>
  <div class="c-app-header-time" :class="`c-app-header-time${customClass}`">
    <div>
      <time role="none" :datetime="`${currentYear}-11`" v-html="$t('global.date')"></time>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customClass: {
      type: String,
      required: false,
      default: ""
    }
  },
  computed: {
    currentYear: () => new Date().getFullYear()
  }
};
</script>

<style lang="scss">
/* this component is user either in the appBar + in the app Nav. Mostly its the same thing but be careful */
.c-app-header-time {
  @media #{$breakpoint-horizontal} {
    position: absolute;
    transform: rotate(-90deg);
    height: $header-width--no-padding;
    transform-origin: 0% 0%;
    width: 100%;
    display: flex;
    align-content: center;
    align-items: center;
  }
  &--mobile {
    @include transform(translateY(-10px));
    opacity: 0;
  }
  div {
    display: block;
    white-space: nowrap;
    color: $color-white;
  }
}
</style>
